import { useEffect, useState } from 'react'
import { FeatureFlag } from 'src/config/featureFlags'
import { FeatureFlagService } from 'src/services/featureFlagService'

export const useFeatureFlag = (feature: FeatureFlag) => {
    const [isEnabled, setIsEnabled] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        let mounted = true

        FeatureFlagService.isEnabled(feature).then((enabled) => {
            if (mounted) {
                setIsEnabled(enabled)
                setIsLoading(false)
            }
        })

        return () => {
            mounted = false
        }
    }, [feature])

    return { isEnabled, isLoading }
}
